import { useQuery } from '@tanstack/react-query';

import { fetchDataInsights } from '@/shared/api/openmetadata';
import type { ChartName, DataInsightsResponse } from '@/shared/api/openmetadata';
import { miscKeys } from '@/shared/lib/query/queryKeys';

const PLATFORM_INSIGHTS_CHARTS: ChartName[] = [
  'assets_with_description',
  'assets_with_pii',
  'assets_with_tier',
  'assets_with_owners',
  'healthy_data_assets',
];

export const useDataInsights = (serviceName: string, startDate: number, endDate: number, enabled: boolean = true) => {
  return useQuery<DataInsightsResponse | null>({
    queryKey: miscKeys.assetDataInsights(serviceName, String(startDate), String(endDate)),
    queryFn: async () => {
      if (!enabled) {
        return null;
      }
      return fetchDataInsights({
        chartNames: PLATFORM_INSIGHTS_CHARTS,
        startDate,
        endDate,
        filter: {
          query: {
            match: {
              'service.name.keyword': serviceName,
            },
          },
        },
      });
    },
    enabled: enabled && !!serviceName && !!startDate && !!endDate,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
};
